'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  CMS: 'cms',
  HUB_MARKETING: 'marketing',
  HUB_SALES: 'sales',
  HUB_SERVICE: 'service'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/Hubs.js
// module id = 16
// module chunks = 3 4 5